export default __webpack_public_path__ + "static/media/6.73c7fce2.jpg";